import TaraSlider from './TaraSlider';

class PostTypeFilter {
  constructor() {
    this.$container = $('body');
    this.$filter = this.$container.find('[data-role="post-type-filter"]');
    this.$target = this.$container.find('[data-role="post-type-target"]');
    this.$carousel = null;
    if (this.$filter.length && this.$target.length) {
      this.initSlick();
      this.initialize();
    }
  }

  initialize() {
    this.$filter.find('button').each((_, button) => {
      const $button = $(button);
      $button.on('click', (evt) => {
        const $el = $(evt.currentTarget);
        if (!$el.hasClass('active')) {
          this.resetButton();
          $el.addClass('active');
          this.initFilter($el.data('term'));
        } else {
          this.resetButton();
          this.resetSlick();
        }
      });
    });
  }

  initFilter(taxonomy) {
    this.$target.find('article').each((_, el) => {
      const $el = $(el);
      if (taxonomy !== $el.data('target')) {
        this.$target.slick('unslick');
        $el.remove();
        TaraSlider('[data-role="post-type-target"]');
      }
    });
  }

  resetButton() {
    this.$filter.find('button').each((_, el) => {
      const $el = $(el);
      $el.removeClass('active');
    });
  }

  resetSlick() {
    this.$target.slick('unslick');
    this.$target.html(this.$carousel);
    TaraSlider('[data-role="post-type-target"]');
  }

  initSlick() {
    this.$carousel = this.$target.html();
    TaraSlider('[data-role="post-type-target"]');
  }
}

export default PostTypeFilter;



// WEBPACK FOOTER //
// ./scripts/components/PostTypeFilter.js